import React from 'react';

interface IPhoneProps {
  phone: string;
}

const Phone = ({ phone }: IPhoneProps) => <>{phone}</>;

export { Phone };
